import { Order } from '@typings';

import { useOrderStatusLabels } from './useOrderStatusLabels';

export const useOrderStatusLabel = (status: Order.Status): string => {
  const orderStatusLabels = useOrderStatusLabels();

  const statusLabel = orderStatusLabels[status];

  return statusLabel ?? '';
};
